import { render, staticRenderFns } from "./needWasteDetail.vue?vue&type=template&id=6951956d&scoped=true"
import script from "./needWasteDetail.vue?vue&type=script&lang=js"
export * from "./needWasteDetail.vue?vue&type=script&lang=js"
import style0 from "./needWasteDetail.vue?vue&type=style&index=0&id=6951956d&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6951956d",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\vescort-platform-pc-website\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('6951956d')) {
      api.createRecord('6951956d', component.options)
    } else {
      api.reload('6951956d', component.options)
    }
    module.hot.accept("./needWasteDetail.vue?vue&type=template&id=6951956d&scoped=true", function () {
      api.rerender('6951956d', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/cooperationMall/newCooperationMall/detail/needWasteDetail.vue"
export default component.exports